export default __webpack_public_path__ + "static/media/Screen1.dd03efca.png";